import { render, staticRenderFns } from "./photo-plug.vue?vue&type=template&id=17ffe599&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/photo-plug/photo-plug.vue
// module id = 1189
// module chunks = 0